import {inject, Service} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {CampaignPriceModel} from '../models/campaign-price.model';
import {finalize, share} from 'rxjs/operators';
import {CampaignRequestModel} from '../models/campaign-request.model';

@Service()
export class CampaignsService {
  private http = inject(HttpClient);

  private campaignsObservable: Observable<CampaignPriceModel[]> | null = null;

  fetch(): Observable<CampaignPriceModel[]> {
    if (!this.campaignsObservable) {
      this.campaignsObservable = this.http
        .get<CampaignPriceModel[]>('/api/campaign-prices')
        .pipe(
          share(),
          finalize(() => this.campaignsObservable = null)
        );
    }

    return this.campaignsObservable;
  }

  update(priceId: number, data: CampaignRequestModel): Observable<CampaignPriceModel> {
    return this.http.put<CampaignPriceModel>('/api/campaign-prices/' + priceId, data);
  }

  add(data: CampaignRequestModel): Observable<CampaignPriceModel> {
    return this.http.post<CampaignPriceModel>('/api/campaign-prices', data);
  }
}
